import type { Season } from '@/modules/Content/interface/Content';
import type { FC } from 'react';
import {
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@eqi-investimentos/react';
import { PATHS } from '@/config/paths';
import { CardHorizontalContentItem } from '@/components/modules/CardHorizontalContentItem';
import { IfRender, MapRender } from '@/utils/jsx';

export const EntertainmentSection: FC<EntertainmentSectionProps> = ({
  programType,
  seasons,
}) => {
  return (
    <IfRender condition={programType === 'entertainment'}>
      <Flex direction="column" gap="l" w="full" mb="5rem">
        <Tabs display="flex" flexDir="column" gap="l">
          <TabList p="0" w="fit-content">
            {seasons?.map(({ title }) => (
              <Tab key={title}>{title}</Tab>
            ))}
          </TabList>
          <TabPanels w="full" p="l" bg="background.brandLight">
            {seasons?.map(({ title, contents }) => (
              <TabPanel key={`${title}-contents`}>
                <Flex direction="column" gap="l">
                  <MapRender
                    items={contents}
                    render={({ duration, slug, title }) => (
                      <CardHorizontalContentItem
                        key={title}
                        href={`${PATHS.hubs.content}/${slug}`}
                        title={title}
                        duration={duration}
                        progress={0}
                      />
                    )}
                  />
                </Flex>
              </TabPanel>
            ))}
          </TabPanels>
        </Tabs>
      </Flex>
    </IfRender>
  );
};

type EntertainmentSectionProps = {
  seasons: Season[];
  programType: string;
};
